import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import { themeColorSet, ThemedText, ThemedView } from "@app/theme"
import Button from "@app/sharedComponents/Button/Button";
import { ActivityIndicator, ScrollView } from "react-native";
import ROUTE from "@app/navigationApp/routes";
import { useEffect, useState } from "react";
import { endpoints } from "@app/api/apis";
import axios from "axios";
import { useAppSelector } from "@app/store/hooks";
import { formatIndianCurrency } from "@app/utils/utility";
import TataLogo from '../../../assets/Icons/TataLogo';
import DSPLogo from '../../../assets/Icons/DSPLogo';
import BajajLogo from '../../../assets/Icons/BajajLogo';
import { WarningCircle } from '@app/sharedComponents/Icons/Icons';

const RenewalSummary = ({navigation,route})=>{
    const daysToRenewal = route?.params?.daysToRenewal;
    const [summaryData,setSummaryData] = useState({});
    const [buttonLoading,setButtonLoading] = useState(false)
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const {creditLimit,interestAutoPay,interestRate,principalRepaymentMode,pledgedPortfolioValue,processingCharges,tenure} = summaryData?.stepResponseObject || {}
    let polling = null
    const [isLoading,setIsLoading] = useState(true)
    const fetchRenwalSummary = (id:string)=>{
        const url = endpoints.renewalSummary + id
        axios.get(url)
        .then((res)=>{
            setSummaryData({...res?.data,renewId:id})
        }).catch((err)=>{
            console.log('fetchPendingRequests',err)
        }).finally(()=>{
            setIsLoading(false)
        })
    }

    const getLenderLogo = (id) => {
        const logoObj ={
        tata: <TataLogo/>,
        bajaj: <BajajLogo/>,
        dsp: <DSPLogo/>,
        }
        return logoObj[id]
    }

    useEffect(()=>{
        // API call to get renewal summary data
        const url = endpoints.enhanceLimit + userDetails?.linkedCredits[0]?.creditId + '/v2';
        const payload = { creditApplicationType:"CREDIT_RENEWAL_AGAINST_SECURITIES"}
        axios.post(url,payload)
        .then((res)=>{
            fetchRenwalSummary(res.data?.applicationId)
        }).catch((err)=>{
            console.log('fetchPendingRequests',err)
        })
    },[])

    const pollRenewalStatus = (response)=>{
        const url = endpoints.renewAppliction + summaryData?.renewId
        axios.get(url)
        .then((res)=>{
            if(res?.data?.applicationState === 'COMPLETED'){
                clearInterval(polling)
                navigation.navigate(ROUTE.RENEWAL_STATUS,{showPageHeader:false})
                setButtonLoading(false)
            }
        })
        .catch((err)=>{
            console.log('fetchPendingRe quests',err)
            setButtonLoading(false)

        })
    }
    const proceedToRenewal = async()=>{
        setButtonLoading(true)
        const url = endpoints.getOfferSelectionInit + summaryData?.renewId
        axios.get(url)
        .then((res)=>{
            polling = setInterval(()=>{
                pollRenewalStatus(res?.data)
            },5000)
        })
        .catch((err)=>{
            console.log('fetchPendingRequests',err)
        })
    }

    return(
        <>
        <PageHeaders pageName={route?.name} label={"Verify renewal summary"} navigation={navigation}/>
        {isLoading ?
        <ThemedView flex={1} backgroundColor="bg-surface-page" p="lg" justifyContent="center" alignItems="center">
            <ActivityIndicator size="large" color={themeColorSet["icon-action-primary"]} />
        </ThemedView>:
        <>
        <ScrollView style ={{backgroundColor:themeColorSet['bg-surface-page'],flex:1}}>
      
            <ThemedView mb="2xl" p="lg" backgroundColor="bg-surface-primary">
                <ThemedText variant="b3r" color="text-secondary" mb="xs">Credit limit</ThemedText>
                <ThemedView flexDirection="row" alignItems="center">
                    <ThemedText variant="l2" color="text-emphasis-secondary">₹</ThemedText>
                    <ThemedText variant="h2b" color="text-emphasis-secondary">{formatIndianCurrency(creditLimit)}</ThemedText>
                </ThemedView>

                <ThemedView height={1} backgroundColor="border-primary" width={"100%"}  my="lg"/>
                <ThemedText variant="b2r" color="text-secondary" mb="xs">Mutual fund value</ThemedText>
                <ThemedText variant="b2b" color="text-primary">₹{formatIndianCurrency(pledgedPortfolioValue)}</ThemedText>
            </ThemedView>
            <ThemedText variant="h4s" color="text-primary" ml="lg" mb="sm">
                Interest and other charges
            </ThemedText>
            <ThemedView p="lg" backgroundColor="bg-surface-primary" mb="2xl">
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3r" color="text-primary">Interest rate</ThemedText>
                    <ThemedText variant="b3s" color="text-primary">{interestRate}%</ThemedText>
                </ThemedView>
                <ThemedView height={1} width={'100%'} my="lg" backgroundColor="border-primary" />
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3r" color="text-primary">Renewal fees (excl. of GST)</ThemedText>
                    <ThemedText variant="b3s" color="text-primary">₹{formatIndianCurrency(processingCharges)}</ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedText variant="h4s" color="text-primary" ml="lg" mb="sm">
                Repayment schedule
            </ThemedText>
            <ThemedView p="lg" backgroundColor="bg-surface-primary" mb="2xl">
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3r" color="text-primary">Tenure</ThemedText>
                    <ThemedText variant="b3s" color="text-primary">{tenure} months</ThemedText>
                </ThemedView>
                <ThemedView height={1} width={'100%'} my="lg" backgroundColor="border-primary" />
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3r" color="text-primary">Interest autopay</ThemedText>
                    <ThemedText variant="b3s" color="text-primary">{interestAutoPay}rd of every month</ThemedText>
                </ThemedView>
                <ThemedView height={1} width={'100%'} my="lg" backgroundColor="border-primary" />
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3r" color="text-primary">Principal repayment</ThemedText>
                    <ThemedText variant="b3s" color="text-primary">{principalRepaymentMode}</ThemedText>
                </ThemedView>
            </ThemedView>
        </ScrollView>
        <ThemedView p="lg" backgroundColor="bg-surface-primary"  alignItems="center" >
            <Button buttonLoader={buttonLoading} label="Confirm and proceed" type="SOLID" handlePress={proceedToRenewal}/>

                <ThemedView width={180} flexDirection="row" alignItems="center"  justifyContent="center" mt="md" borderWidth={1} borderColor="border-primary"  borderRadius="xs">
                    <ThemedView borderRightWidth={1} borderColor="border-primary" mr="sm" pr="sm">
                        <ThemedText variant="b5r" color="text-primary" mb="xs">Lending partner</ThemedText>
                    </ThemedView>
                    <ThemedView>
                        {getLenderLogo(summaryData?.updatedApplicationObj?.lenderAccountId?.toLowerCase())}
                    </ThemedView>
                </ThemedView>

        </ThemedView>
        </>
        }
        </>
    )
}

export default RenewalSummary;